import axios from "axios";

const putPrescription = async (baseUrl, token, doctorId, appointmentId, patientId, medicineList) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    await axios.put(baseUrl + "/doctor/" + doctorId + "/appointment/" + appointmentId + "/prescription/" + patientId, medicineList, config)
        .then((res) => {
            //console.log("res.data: ", res.data)
            putResponse = {
                status: res.status,
                data: res.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    data: error.response.status
                }
            }
        });
    return putResponse
}

export default putPrescription;
